<template>
  <div>
    <v-layout>
      <v-flex class="content-main mt-7 mx-auto headline">
        <v-flex class="content">
          <v-layout class="font-weight-bold primary--text">
            ระบุเลขประจำตัวคนไม่มีสัญชาติไทย
          </v-layout>
          <v-layout>
            <v-flex>
              <v-text-field v-model="pid" dense hide-details="auto" v-mask="'#-####-#####-##-#'"
                placeholder="X-XXXX-XXXXX-XX-X" outlined />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex mt-3>
              <center>
                <vue-recaptcha ref="recaptcha" sitekey="6LfObToiAAAAAGj6EQ6fofEmbUbVtE0A1WS3FsmQ"
                  @verify="verifyRecaptcha(true)" @expired="verifyRecaptcha(false)" @error="verifyRecaptcha(false)" />
              </center>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-btn @click="submit" :disabled="isSubmit" class="rounded mt-3" color="primary" block>ค้นหา</v-btn>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout v-if="items">
      <contentMobileComponent v-if="isMobile" :items="items"></contentMobileComponent>
      <contentWebComponent :items="items"></contentWebComponent>
    </v-layout>
  </div>
</template>
  
<script>
import nonStatusAPI from "@/api/non-status.js"
import registerNatAPI from "@/api/register-nat.js"
import displacedAPI from "@/api/displaced.js"
import contentWebComponent from "@/components/content-web-component.vue"
import contentMobileComponent from "@/components/content-mobile-component.vue"
import { VueRecaptcha } from 'vue-recaptcha';
import Swal from 'sweetalert2'
export default {
  name: "search",
  components: {
    contentWebComponent,
    contentMobileComponent,
    VueRecaptcha
  },
  data() {
    return {
      pid: null,
      items: null,
      isRecaptcha: false,
      isSubmit: false,
      isMobile:false
    };
  },
  watch: {
    pid: function () {
      this.items = null;
    }
  },
  mounted() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      this.isMobile = true;
    }else{
      this.isMobile = false;
    }
  },
  methods: {
    sweetOpenTimer(msg) {
      this.isSubmit = true;
      return Swal.fire({ title: msg, timerProgressBar: true, didOpen: () => { Swal.showLoading() } });
    },
    sweetCloseTimer() {
      this.isSubmit = false;
      return Swal.close();
    },
    sweetAlert(type, msg) {
      return Swal.fire({ icon: type, title: 'แจ้งเตือน', text: msg, confirmButtonText: 'ตกลง' });
    },
    getStatusList(key){
      let status = [];
      if(key == 1){
        status.push({code:1,desc:"ออกใบรับคำร้อง"});
        status.push({code:2,desc:"นายทะเบียนตรวจสอบอนุมัติ/นายทะเบียนตรวจสอบไม่อนุมัติ"});
        status.push({code:3,desc:"นายทะเบียนส่งเอกสารคำขอให้จังหวัด"});
        status.push({code:4,desc:"นายอำเภอตรวจสอบอนุมัติ/นายอำเภอตรวจสอบไม่อนุมัติ"});
        status.push({code:5,desc:"ส่งเอกสารไปกรมการปกครอง2543และม23"});
        status.push({code:6,desc:"จังหวัดรับเอกสารคำขอ"});
        status.push({code:7,desc:"จังหวัดไม่อนุมัติ"});
        status.push({code:8,desc:"จังหวัดส่งเอกสารคำขอให้กรมการปกครอง"});
        status.push({code:9,desc:"กรมการปกครองรับเอกสารคำขอ"});
        status.push({code:10,desc:"กรมการปกครองกำหนดเลขใหม่"});
        status.push({code:11,desc:"กรมการปกครองส่งรายงานให้อำเภอ"});
        status.push({code:12,desc:"อำเภอเปลี่ยนสถานภาพทร.98"});
      }else if(key == 2){
        status.push({code:1,desc:"บันทึกแบบคำขอ"});
        status.push({code:2,desc:"เจ้าพนักงานตรวจสอบหลักฐาน"});
        status.push({code:3,desc:"นายอำเภอตรวจสอบหลักฐาน"});
        status.push({code:4,desc:"สนท.ส่งเอกสารให้จังหวัด"});
        status.push({code:5,desc:"จังหวัดตรวจสอบเอกสาร"});
        status.push({code:6,desc:"จังหวัดส่งแบบคำขอให้ส่วนกลาง"});
        status.push({code:7,desc:"ส่วนกลางรับเอกสารคำขอ"});
        status.push({code:8,desc:"ส่วนกลางส่งเรื่องเข้าประชุมพิจารณา"});
        status.push({code:9,desc:"ผลการพิจารณาคำขอจากคณะกรรมการ"});
        status.push({code:10,desc:"เจ้าหน้าที่ส่วนกลางออกหนังสือรับรอง"});
        status.push({code:11,desc:"ส่วนกลางกำหนดเลขประจำตัว"});
        status.push({code:12,desc:"สนท.ดำเนินการเปลี่ยนสถานภาพด้วย ท.ร 98"});
      }else if(key == 3){
        status.push({code:10,desc:"ลงทะเบียนออกคำขอ"});
        status.push({code:11,desc:"นายอำเภอ/ผอ.สำนักกิจการความมั่นคงภายใน อนุมัติ"});
        status.push({code:12,desc:"นายอำเภอ/ผอ.สำนักกิจการความมั่นคงภายใน ไม่อนุมัติ"});
        status.push({code:13,desc:"ส่งรายการให้ ปค.จังหวัด"});
        status.push({code:14,desc:"รายการอยู่ที่ สนท. เอกสารยังไม่ครบ"});
        status.push({code:21,desc:"ปค.จังหวัดรับรายการ"});
        status.push({code:22,desc:"ปค.จังหวัดส่งรายการให้ ส่วนกลาง"});
        status.push({code:23,desc:"ปค.จังหวัดส่งรายการคืน อำเภอ"});
        status.push({code:31,desc:"ส่วนกลางรับรายการ"});
        status.push({code:32,desc:"ส่วนกลางส่งรายการให้ 5 หน่วยงาน"});
        status.push({code:34,desc:"รัฐมนตรีพิจารณาอนุญาต"});
        // status.push({code:35,desc:"แสกนเอกสารการอนุญาตให้สถานะฯ"});
      }

      return status;
    },
    getGroup(key) {
      if (!key) return "-";
      if (key == 1) return "ตรวจสอบสถานะคำขอลงรายการสัญชาติไทย";
      if (key == 2) return "ตรวจสอบสถานะคำขอคนไทยพลัดถิ่น";
      if (key == 3) return "ตรวจสอบสถานะคำขอใบสำคัญถิ่นที่อยู่";
      return "-"
    },
    emptyOrNull(data, blank = null) {
      if (!data) return blank;
      if (typeof data === 'string') return String(data).trim() ? String(data).trim() : blank;
      return data;
    },
    verifyRecaptcha(flag) {
      this.isRecaptcha = flag;
    },
    async submit() {
      //0-1206-89002-09-1
      this.items = null;
      if (!this.pid) return this.sweetAlert('warning', "กรุณาระบุเลขประจำตัว");
      const pid = this.pid.replaceAll("-", "");
      if (String(pid).length != 13) return this.sweetAlert('warning', "กรุณาระบุเลขประจำตัวให้ครบ 13 หลัก");
      if (!this.checkThaiPID(pid)) return this.sweetAlert('warning', "เลขประจำตัวไม่ถูกต้อง");
      if (!this.isRecaptcha) return this.sweetAlert('warning', "กรุณาทำการยืนยันตัวตน");

      this.sweetOpenTimer('กรุณารอสักครู่...');
      let dataList = [];
      dataList.push(await this.nonStatusApiFN(pid));
      dataList.push(await this.registerNatApiFN(pid));
      dataList.push(await this.displacedApiFN(pid));
      this.sweetCloseTimer();
      dataList = dataList.filter(item => !!item);
      if (!dataList.length) return this.sweetAlert('warning', "ไม่พบข้อมูล");
      this.items = JSON.parse(JSON.stringify(dataList))
    },
    setData(flag, pid, data,pdf=null) {
      return {
        title: this.getGroup(this.emptyOrNull(flag)),
        pid: this.PIDFormat(pid),
        firstname: this.emptyOrNull(data.firstName),
        reqDate: this.emptyOrNull(data.dateDescription),
        reqRcode: this.emptyOrNull(data.placeDescription),
        status: {
          code: this.emptyOrNull(data.statusCode),
          desc: this.emptyOrNull(data.statusDescription),
        },
        statusList: this.getStatusList(flag),
        flag,
        pdf,
      }
    },
    async nonStatusApiFN(pid) {
      const result = await nonStatusAPI.get(`/register/online/status/${pid}`);
      if (result.error) return null;

      if(result.data.statusCode == 35){
        const rcode = result.data.rcode;
        const reqYear = result.data.reqYear;
        const reqNo = result.data.reqNo;
        const resultPDF = await nonStatusAPI.get(`/register/online/status/${rcode}/${reqYear}/${reqNo}/${pid}`);
        if (resultPDF.error) return null;
        return this.setData(3, pid, result.data,resultPDF.data);
      }
      return this.setData(3, pid, result.data);
    },
    async registerNatApiFN(pid) {
      const result = await registerNatAPI.get(`/status/${pid}`);
      if (result.error) return null;
      return this.setData(1, pid, result.data);
    },
    async displacedApiFN(pid) {
      const result = await displacedAPI.get(`/status/${pid}`);
      if (result.error) return null;
      return this.setData(2, pid, result.data);
    }
  },
};
</script>
<style lang="scss" scoped>
.v-btn:not(.v-btn--round).v-size--default {
  height: 2.5rem;
}

.v-btn.v-size--default {
  font-size: 1.25rem;
}

.v-input {
  font-size: 1.25rem;
  letter-spacing: normal;
  max-width: 100%;
  text-align: left;
}

.content-main {
  max-width: 40rem;
  // font-size: 1.5rem;
  // color: black;
}

.content {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 5px;
  border: 0.063rem solid #ddd;
  padding: 1.25rem;
  background: #fff;
  margin: 0 1rem 1rem 1rem;
}
</style>
  